import { useLocation } from 'react-router-dom';

const usePageTitle = () => {
    const { pathname } = useLocation();
    const normalizedPath = pathname.replace(/^\/admin\/u\/[^/]+/, '') || '/';

    switch (true) {
        case normalizedPath === '/':
            return 'Dashboard';
        case normalizedPath.startsWith('/add-trade'):
            return 'Upload Trade';
        case normalizedPath.startsWith('/calendar'):
            return 'Calendar';
        case normalizedPath.startsWith('/settings'):
            return 'Settings';
        case normalizedPath.startsWith('/summary'):
            return 'Statistics';
        case normalizedPath.startsWith('/trades'):
            return 'Trades';
        case normalizedPath.startsWith('/compare'):
            return 'Compare';
        case normalizedPath.startsWith('/daily-trade-notes'):
            return 'Daily Notes';
        default:
            return 'Default Title'; // Fallback title
    }
};

export default usePageTitle;
